/**
 * Global search: the header control and the search palette. Result group
 * labels and hits come from the API. Conventions: see `common.ts`.
 */
const search: Record<string, string> = {
  close: 'Close search',
  empty_prompt: 'Find anything in {business}',
  searching: 'Searching…',
  unavailable: 'Search is unavailable right now. Try again in a moment.',
  no_results: 'No results for “{term}”',
  results_label: 'Search results',
  see_all: 'See all {label}',
  in_parent: 'in {parent}',

  'scope.PRODUCT': 'Products',
  'scope.ORDER': 'Orders',
  'scope.CUSTOMER': 'Customers',
  'scope.DISCOUNT': 'Discounts',
  'scope.PAGE': 'Pages & features',

  'groups.pages': 'Pages',
  'groups.features': 'Features',
  'groups.recent': 'Recently visited',
};

export default search;
